
export class MultiSelectAutoCompleteModel<T> {
  /** The identifier of the object */
  identifier: string;
  /** the total number of possibilities which can corresponds to the filter */
  nbTotal: number;
  /** The key to translate for the label */
  keyAfterTotal: string;
  /** all selected values */
  allSelectedValues: T[] = [];
  /** key to translate for the placeholder */
  placeholderKey: string;
  /** function used to refresh selection choice (to use in html) */
  fetchChoices: (searchTerm: string, page: number) => Promise<T[]>;
  constructor(
    identifier: string,
    keyToAfterTotal: string,
    placeholderKey: string,
    fetchChoices: (searchTerm: string, page: number) => Promise<T[]>
  ) {
    this.identifier = identifier;
    this.keyAfterTotal = keyToAfterTotal;
    this.placeholderKey = placeholderKey;
    this.fetchChoices = fetchChoices;
  }
}